import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from './baseQuery';

export interface ITopView {
  top_views_id: number;
  top_views_image_url: string;
  top_views_transition_url: string;
  top_views_sort: number;
  top_views_suspended: number;
}

// Define a service using a base URL and expected endpoints
export const topViewApi = createApi({
  reducerPath: 'top_view',
  tagTypes: ['topView'],
  baseQuery: axiosBaseQuery(),
  endpoints: builder => ({
    getAllTopView: builder.query<ITopView[], void>({
      query: () => ({ url: '/top_views', method: 'GET' }),
      providesTags: ['topView'],
      transformResponse: (response: { data_response: ITopView[] }, meta, arg) =>
        response.data_response,
    }),
    createTopView: builder.mutation<any, any>({
      query(body) {
        return {
          url: '/top_views',
          method: 'POST',
          data: body,
        };
      },
      invalidatesTags: ['topView'],
    }),
    deleteTopView: builder.mutation<any, string>({
      query(id) {
        return {
          url: `/top_views/${id}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: ['topView'],
    }),
    updateTopView: builder.mutation<any, any>({
      query({ id, body }) {
        return {
          url: `/top_views/${id}`,
          method: 'PUT',
          data: body,
        };
      },
      invalidatesTags: ['topView'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllTopViewQuery,
  useCreateTopViewMutation,
  useDeleteTopViewMutation,
  useUpdateTopViewMutation,
} = topViewApi;
